import { default as angular } from "angular";
import uiRouter from "@uirouter/angularjs/lib-esm";

import { routeConfig } from "./routes";


import {
  vsComponentName as WebJobsComponentName,
  webJobsComponentOptions,
} from "./view/grid/component";
import {
  vsComponentName as WebJobsDetailComponentName,
  WebJobDetailComponentOptions,
} from "./view/detail/component";
import { moduleName as recordsModuleName } from "../records";

export const vsName = "SlotTrak.WebJob";

angular
  .module(vsName, [uiRouter,
    recordsModuleName]
  )
  .config(routeConfig)
  
  .component(
    WebJobsComponentName,
    webJobsComponentOptions
  )
  .component(
    WebJobsDetailComponentName,
    WebJobDetailComponentOptions
  );
  
export default vsName; 